// src/theme.js

// 1. Define your client palettes
const PALETTES = {
  // Default (Blue/Green/Orange)
  default: {
    primary: '#2c3e50',    // Navy
    secondary: '#27ae60',  // Green
    accent: '#e67e22',     // Orange
    background: '#f4f6f8',
    navbarBg: '#2c3e50',   // Navbar background
    navbarText: '#ffffff'
  },
  // Anglian Water (Example: Blues)
  anglian: {
    primary: '#005492',
    secondary: '#009cdf',
    accent: '#ffc20e',
    background: '#f0f8ff',
    navbarBg: '#005492',
    navbarText: '#ffffff'
  },
  // South Staffs (Example: Green/Teal)
  southStaffs: {
    primary: '#006b54',
    secondary: '#4ab497',
    accent: '#f39c12',
    background: '#fafffd',
    navbarBg: '#006b54',
    navbarText: '#ffffff'
  },
// 👇 ADD THIS NEW PALETTE
  riverbid: {
    primary: '#163321',    // Primary Earth 
    accent: '#F59E0B',  // UI Accent Amber
    secondary: '#0D9488',     // Action Teal
    background: '#F8FAFC', // Background Base
    navbarBg: '#163321',   // Matches primary
    navbarText: '#F8FAFC'
  }
};

// 2. Select the current client here
const CURRENT_CLIENT = 'riverbid'; // Change to 'anglian' or 'southStaffs' or riverbid

export const theme = {
  // Branding Config
  branding: {
    clientName: "RiverBid",       // Appears in top left
    appName: "Catchment Actions Portal", // Appears next to client name
    logoUrl: '/clients/dbe-logo.svg',// Put path from public/clients string and filename here
  },
  
  // Colors (Spread the selected palette)
  colors: PALETTES[CURRENT_CLIENT],
  
  // Shared styles
  spacing: (factor) => `${8 * factor}px`,
};